import { createReducer, on } from '@ngrx/store';

import { OrderCreateRequest, OrderInquiryResponseRow } from '#types/order';

import { OrderActions } from '@order/state';

export interface OrderState {
  create: OrderCreateRequest;
  detail: OrderInquiryResponseRow;
  addItem: {
    display: boolean;
    step: number;
    item: string;
    description: string;
    lotNumber: string;
    uom: string;
    weightOrUom: string;
    quantity: number;
    weight: number;
    weightUom: string;
    passthru: {
      dtlpassthruchar01: string;
      dtlpassthruchar02: string;
      dtlpassthruchar03: string;
      dtlpassthruchar04: string;
      dtlpassthruchar05: string;
      dtlpassthruchar06: string;
      dtlpassthruchar07: string;
      dtlpassthruchar08: string;
      dtlpassthruchar09: string;
      dtlpassthruchar10: string;
      dtlpassthruchar11: string;
      dtlpassthruchar12: string;
      dtlpassthruchar13: string;
      dtlpassthruchar14: string;
      dtlpassthruchar15: string;
      dtlpassthruchar16: string;
      dtlpassthruchar17: string;
      dtlpassthruchar18: string;
      dtlpassthruchar19: string;
      dtlpassthruchar20: string;
      dtlpassthruchar21: string;
      dtlpassthruchar22: string;
      dtlpassthruchar23: string;
      dtlpassthruchar24: string;
      dtlpassthruchar25: string;
      dtlpassthruchar26: string;
      dtlpassthruchar27: string;
      dtlpassthruchar28: string;
      dtlpassthruchar29: string;
      dtlpassthruchar30: string;
      dtlpassthruchar31: string;
      dtlpassthruchar32: string;
      dtlpassthruchar33: string;
      dtlpassthruchar34: string;
      dtlpassthruchar35: string;
      dtlpassthruchar36: string;
      dtlpassthruchar37: string;
      dtlpassthruchar38: string;
      dtlpassthruchar39: string;
      dtlpassthruchar40: string;
      dtlpassthrudate01: string;
      dtlpassthrudate02: string;
      dtlpassthrudate03: string;
      dtlpassthrudate04: string;
      dtlpassthrudoll01: number;
      dtlpassthrudoll02: number;
      dtlpassthrunum01: number;
      dtlpassthrunum02: number;
      dtlpassthrunum03: number;
      dtlpassthrunum04: number;
      dtlpassthrunum05: number;
      dtlpassthrunum06: number;
      dtlpassthrunum07: number;
      dtlpassthrunum08: number;
      dtlpassthrunum09: number;
      dtlpassthrunum10: number;
      dtlpassthrunum11: number;
      dtlpassthrunum12: number;
      dtlpassthrunum13: number;
      dtlpassthrunum14: number;
      dtlpassthrunum15: number;
      dtlpassthrunum16: number;
      dtlpassthrunum17: number;
      dtlpassthrunum18: number;
      dtlpassthrunum19: number;
      dtlpassthrunum20: number;
    };
  };
  updateItem: {
    display: boolean;
    lotNumber: string;
    uom: string;
    weightOrUom: string;
    quantity: number;
    weight: number;
    weightUom: string;
    item: string;
  };
}

export const initialState: OrderState = {
  create: null,
  detail: null,
  addItem: {
    display: false,
    step: 0,
    item: null,
    description: null,
    lotNumber: null,
    uom: null,
    weightOrUom: null,
    quantity: null,
    weight: null,
    weightUom: null,
    passthru: null,
  },
  updateItem: {
    display: false,
    lotNumber: null,
    uom: null,
    weightOrUom: null,
    quantity: null,
    weight: null,
    weightUom: null,
    item: null,
  },
};

export const reducer = createReducer<OrderState>(
  initialState,

  //
  // order / inquiry / detail
  //

  on(
    OrderActions.InquiryDetailClearData,
    (state): OrderState => ({
      ...state,
      detail: null,
    })
  ),

  on(
    OrderActions.InquiryDetailSetData,
    (state, action): OrderState => ({
      ...state,
      detail: {
        ...action.data,
      },
    })
  ),

  //
  // order / detail / update item
  //

  on(
    OrderActions.UpdateItemDialogOpen,
    (state): OrderState => ({
      ...state,
      updateItem: {
        ...state.updateItem,
        display: true,
      },
    })
  ),

  on(
    OrderActions.UpdateItemDialogClose,
    (state): OrderState => ({
      ...state,
      updateItem: {
        ...state.updateItem,
        display: false,
      },
    })
  ),

  on(
    OrderActions.UpdateItemRequest,
    (state, action): OrderState => ({
      ...state,
      updateItem: {
        ...state.updateItem,
        lotNumber: action.payload.lotNumber,
        uom: action.payload.uom,
        weightOrUom: action.payload.weightOrUom,
        quantity: action.payload.quantity,
        weight: action.payload.weight,
        weightUom: action.payload.weightUom,
        item: action.payload.item,
      },
    })
  ),

  //
  // order / detail / add item
  //

  on(
    OrderActions.AddItemDialogOpen,
    (state): OrderState => ({
      ...state,
      addItem: {
        ...state.addItem,
        display: true,
        step: 0,
      },
    })
  ),

  on(
    OrderActions.AddItemDialogClose,
    (state): OrderState => ({
      ...state,
      addItem: {
        ...state.addItem,
        display: false,
        step: 0,
      },
    })
  ),

  on(
    OrderActions.AddItemDialogSetStep,
    (state, action): OrderState => ({
      ...state,
      addItem: {
        ...state.addItem,
        step: action.step,
      },
    })
  ),

  on(
    OrderActions.AddItemDialogSetItem,
    (state, action): OrderState => ({
      ...state,
      addItem: {
        ...state.addItem,
        item: action.item,
        description: action.description,
        lotNumber: null,
        uom: null,
        weightOrUom: null,
        quantity: null,
        weight: null,
        passthru: null,
      },
    })
  ),

  on(
    OrderActions.AddItemDialogSetItemDetail,
    (state, action): OrderState => ({
      ...state,
      addItem: {
        ...state.addItem,
        lotNumber: action.lotNumber,
        uom: action.uom,
        weightOrUom: action.weightOrUom,
        quantity: action.quantity,
        weight: action.weight,
        weightUom: action.weightUom,
      },
    })
  ),

  on(
    OrderActions.AddItemDialogClearItem,
    (state): OrderState => ({
      ...state,
      addItem: {
        ...state.addItem,
        item: null,
        description: null,
        lotNumber: null,
        uom: null,
        weightOrUom: null,
        quantity: null,
        weight: null,
        weightUom: null,
        passthru: null,
      },
    })
  ),

  on(
    OrderActions.AddItemDialogStep0ToStep1,
    (state, action): OrderState => ({
      ...state,
      addItem: {
        ...state.addItem,
        step: 1,
        item: action.item,
        description: action.description,
        lotNumber: null,
        uom: null,
        weightOrUom: null,
        quantity: null,
        weight: null,
        weightUom: null,
        passthru: null,
      },
    })
  ),

  on(
    OrderActions.AddItemDialogStep1ToStep2,
    OrderActions.AddItemDialogStep1ToComplete,
    (state, action): OrderState => ({
      ...state,
      addItem: {
        ...state.addItem,
        step: 2,
        lotNumber: action.lotNumber,
        uom: action.uom,
        weightOrUom: action.weightOrUom,
        quantity: action.quantity,
        weight: action.weight,
        weightUom: action.weightUom,
      },
    })
  ),

  on(
    OrderActions.AddItemDialogStep2ToComplete,
    (state, action): OrderState => ({
      ...state,
      addItem: {
        ...state.addItem,
        passthru: {
          dtlpassthruchar01: action.dtlpassthruchar01,
          dtlpassthruchar02: action.dtlpassthruchar02,
          dtlpassthruchar03: action.dtlpassthruchar03,
          dtlpassthruchar04: action.dtlpassthruchar04,
          dtlpassthruchar05: action.dtlpassthruchar05,
          dtlpassthruchar06: action.dtlpassthruchar06,
          dtlpassthruchar07: action.dtlpassthruchar07,
          dtlpassthruchar08: action.dtlpassthruchar08,
          dtlpassthruchar09: action.dtlpassthruchar09,
          dtlpassthruchar10: action.dtlpassthruchar10,
          dtlpassthruchar11: action.dtlpassthruchar11,
          dtlpassthruchar12: action.dtlpassthruchar12,
          dtlpassthruchar13: action.dtlpassthruchar13,
          dtlpassthruchar14: action.dtlpassthruchar14,
          dtlpassthruchar15: action.dtlpassthruchar15,
          dtlpassthruchar16: action.dtlpassthruchar16,
          dtlpassthruchar17: action.dtlpassthruchar17,
          dtlpassthruchar18: action.dtlpassthruchar18,
          dtlpassthruchar19: action.dtlpassthruchar19,
          dtlpassthruchar20: action.dtlpassthruchar20,
          dtlpassthruchar21: action.dtlpassthruchar21,
          dtlpassthruchar22: action.dtlpassthruchar22,
          dtlpassthruchar23: action.dtlpassthruchar23,
          dtlpassthruchar24: action.dtlpassthruchar24,
          dtlpassthruchar25: action.dtlpassthruchar25,
          dtlpassthruchar26: action.dtlpassthruchar26,
          dtlpassthruchar27: action.dtlpassthruchar27,
          dtlpassthruchar28: action.dtlpassthruchar28,
          dtlpassthruchar29: action.dtlpassthruchar29,
          dtlpassthruchar30: action.dtlpassthruchar30,
          dtlpassthruchar31: action.dtlpassthruchar31,
          dtlpassthruchar32: action.dtlpassthruchar32,
          dtlpassthruchar33: action.dtlpassthruchar33,
          dtlpassthruchar34: action.dtlpassthruchar34,
          dtlpassthruchar35: action.dtlpassthruchar35,
          dtlpassthruchar36: action.dtlpassthruchar36,
          dtlpassthruchar37: action.dtlpassthruchar37,
          dtlpassthruchar38: action.dtlpassthruchar38,
          dtlpassthruchar39: action.dtlpassthruchar39,
          dtlpassthruchar40: action.dtlpassthruchar40,
          dtlpassthrudate01: action.dtlpassthrudate01,
          dtlpassthrudate02: action.dtlpassthrudate02,
          dtlpassthrudate03: action.dtlpassthrudate03,
          dtlpassthrudate04: action.dtlpassthrudate04,
          dtlpassthrudoll01: action.dtlpassthrudoll01,
          dtlpassthrudoll02: action.dtlpassthrudoll02,
          dtlpassthrunum01: action.dtlpassthrunum01,
          dtlpassthrunum02: action.dtlpassthrunum02,
          dtlpassthrunum03: action.dtlpassthrunum03,
          dtlpassthrunum04: action.dtlpassthrunum04,
          dtlpassthrunum05: action.dtlpassthrunum05,
          dtlpassthrunum06: action.dtlpassthrunum06,
          dtlpassthrunum07: action.dtlpassthrunum07,
          dtlpassthrunum08: action.dtlpassthrunum08,
          dtlpassthrunum09: action.dtlpassthrunum09,
          dtlpassthrunum10: action.dtlpassthrunum10,
          dtlpassthrunum11: action.dtlpassthrunum11,
          dtlpassthrunum12: action.dtlpassthrunum12,
          dtlpassthrunum13: action.dtlpassthrunum13,
          dtlpassthrunum14: action.dtlpassthrunum14,
          dtlpassthrunum15: action.dtlpassthrunum15,
          dtlpassthrunum16: action.dtlpassthrunum16,
          dtlpassthrunum17: action.dtlpassthrunum17,
          dtlpassthrunum18: action.dtlpassthrunum18,
          dtlpassthrunum19: action.dtlpassthrunum19,
          dtlpassthrunum20: action.dtlpassthrunum20,
        },
      },
    })
  ),

  on(
    OrderActions.AddItemDialogStep1ToStep0,
    (state): OrderState => ({
      ...state,
      addItem: {
        ...state.addItem,
        step: 0,
      },
    })
  ),

  on(
    OrderActions.AddItemDialogStep2ToStep1,
    (state): OrderState => ({
      ...state,
      addItem: {
        ...state.addItem,
        step: 1,
      },
    })
  ),

  //
  // order / create
  //

  on(
    OrderActions.CreateOrderInit,
    OrderActions.CreateOrderSetValues,
    (state, action): OrderState => ({
      ...state,
      create: {
        orderType: action.payload.orderType,
        uniqueOrderIdentifier: action.payload.uniqueOrderIdentifier,
        inbound: {
          ...action.payload.inbound,
        },
        outbound: {
          ...action.payload.outbound,
        },
        shipping: {
          ...action.payload.shipping,
        },
        billing: {
          ...action.payload.billing,
        },
        additionalInfo: {
          ...action.payload.additionalInfo,
        },
      },
    })
  ),

  on(
    OrderActions.CreateOrderClearValues,
    (state): OrderState => ({
      ...state,
      create: null,
    })
  ),

  on(
    OrderActions.CreateOrderRequestSuccess,
    (state, action): OrderState => ({
      ...state,
      detail: {
        modifiable: 'Y',
        custid: action.data[0].custid,
        orderid: action.data[0].orderid,
        shipid: action.data[0].shipid,
        ordershipid: `${action.data[0].orderid}-${action.data[0].shipid}`,
        fromfacility: action.data[0].fromfacility,
        tofacility: action.data[0].tofacility,
        orderstatus: action.data[0].orderstatus,
        orderstatusabbrev: action.data[0].orderstatusabbrev,
        ordertype: action.data[0].ordertype,
        ordertypeabbrev: action.data[0].ordertypeabbrev,
      },
    })
  )
);
